import React, { Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import LoadingHomepage from "./pages/maintence/components/LoadingHomepage";

// 预约维保
import Reservation from "./pages/reservation";

// 组件 DEMO
// import Examples from "./pages/examples";

// 404
import NoMatch from "./pages/no-match";

// 订单
import ServicesOrders from "./pages/serviceOrders";

// 感恩卡
import ThanksgivingCardNew from "./pages/thanksgiving-card-new";

// 保养报告
const MaintenanceReport = lazy(() => import('./pages/maintenance-report'));

function App() {
  return (
    <Switch>
      <Route path="/reservation">
        <Reservation />
      </Route>
      {/* <Route path="/examples">
        <Examples />
      </Route> */}
      <Route path="/order" render={({ location: { pathname, search } }) => {
        return <Redirect to={`${pathname.replace(/^\/order/, '/serviceOrders')}${search}`} />
      }}/>
      <Route path="/serviceOrders">
        <ServicesOrders />
      </Route>
      <Route path="/thanksgivingcard" render={({ location }) => <Redirect to={`/thanksgivingCardNew${location.search}`} />} />
      <Route path="/thanksgivingCardNew">
        <ThanksgivingCardNew />
      </Route>
      <Route path="/maintreport">
        <Suspense fallback={<LoadingHomepage />}>
          <MaintenanceReport />
        </Suspense>
      </Route>
      <Route>
        <NoMatch />
      </Route>
    </Switch>
  );
}

export default App;
